import {Injectable} from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable({   providedIn: 'root' })
export class CustomPaginatorService extends MatPaginatorIntl {
  itemsPerPageLabel = 'Nb. d\'éléments par page';
  nextPageLabel = 'Page suivante';
  previousPageLabel = 'Page précédente';

  firstPageLabel = '1ère page';
  lastPageLabel = 'dernière page';

  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `aucun élément`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} sur ${length}`;
  }
}
